import {
    createApp
} from 'vue'
import App from './App.vue'
import router from '@/router'
import store from "@/store";
import Toast from "vue-toastification";
import VueECharts from "vue-echarts";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { PieChart } from "echarts/charts";
import { TooltipComponent, LegendComponent } from "echarts/components";

import '@/assets/main.css'
import "vue-toastification/dist/index.css";

const app = createApp(App)

use([CanvasRenderer, PieChart, TooltipComponent, LegendComponent]);

app.use(router)
app.use(store);
app.use(Toast, {
  duration: 1000,
  position: "top-center",
});
app.component("v-chart", VueECharts);
app.mount('#app')